import {Chip, Grid, Typography} from "@mui/material";
import React from "react";
import {useBooking} from "../../context/booking";
import {useLocalization} from "../../i18n";
import {notBlank} from "../../utils";

export function BookingHeader() {
	const {t} = useLocalization();
	const {booking: {bookingCode} = {}} = useBooking();
	return (
		<Grid
			container
			alignItems="baseline"
			justifyContent="space-between"
			spacing={2}
		>
			<Grid
				item
				xs={12}
				sm="auto"
			>
				{t("booking.title")}
			</Grid>
			{notBlank(bookingCode) && (
				<Grid
					item
					xs={12}
					sm="auto"
				>
					<Grid
						container
						alignItems="baseline"
						spacing={2}
					>
						<Grid item>{t("booking.bookingCode")}:</Grid>
						<Grid item>
							<Chip
								label={<Typography variant="h4" component="div">{bookingCode}</Typography>}
							/>
						</Grid>
					</Grid>
				</Grid>
			)}
		</Grid>
	);
}
